import {formatISO, parseISO} from "date-fns";
import {fromZonedTime} from 'date-fns-tz';

export function dateToIsoDateStringWithCorrectTimezone(date: Date): string {
  return formatISO(fromZonedTime(parseISO(date.toISOString()), 'Europe/Berlin'));
}
